import React from 'react';
import { Descriptions, Modal } from 'antd';
import PropTypes from 'prop-types';
import IntlMessage from '../../../components/IntlMessage';
import { formatCurrency } from '../../../helpers/helpers';

const ModalInfo = ({ open, onClose, item }) => {
  console.log('item', item);
  return (
    <Modal
      title={<IntlMessage id="global.cashier_info" />}
      open={open}
      width={'90%'}
      className="modal_cashier"
      onCancel={onClose}>
      <Descriptions bordered>
        <Descriptions.Item
          span={3}
          label={<IntlMessage id="global.cashier_name" />}>
          {item?.userOperator?.user?.firstname +
            ' ' +
            item?.userOperator?.user?.lastname}
        </Descriptions.Item>
        <Descriptions.Item span={3} label={<IntlMessage id="global.email" />}>
          {item?.userOperator?.user?.email}
        </Descriptions.Item>
        <Descriptions.Item span={3} label={<IntlMessage id="global.city" />}>
          {item?.userOperator?.operator?.title}
        </Descriptions.Item>
        <Descriptions.Item span={3} label={<IntlMessage id="global.mobile" />}>
          {item?.userOperator?.user?.mobile}
        </Descriptions.Item>
        <Descriptions.Item
          span={3}
          label={<IntlMessage id="global.balance_pending" />}>
          <div>
            Tickets payés:{' '}
            <span style={{ color: 'red' }}>
              {formatCurrency(item?.total_ticket_pending || 0)}
            </span>
          </div>
          <div>
            Bagages:{' '}
            <span style={{ color: 'red' }}>
              {formatCurrency(Number(item?.total_luggage_summary_pending || 0))}
            </span>
          </div>
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

ModalInfo.propType = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

ModalInfo.defaultProps = {
  open: false,
  onClose: () => {},
};

export default ModalInfo;
